
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migration",
      function () {
        return require("private-next-pages/migration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migration"])
      });
    }
  